import React from "react";
import { Container, Row, Col } from "reactstrap";
import logoDark from "../../assets/basicTheme/images/logo-2.png";
const Footer = () => {
  return (
    <React.Fragment>
      <footer className="footer-internal">
        <Container fluid={true}>
          <Row className="footer-internal-color">
            <Col sm={12} className="logo">
              <span className="logo-lg">
                <img src={logoDark} alt="" height="35" />
              </span>
              <span className="logo-sm">
                <img src={logoDark} alt="" height="25" />{" "}
              </span>
              <span className="logo-xsm">
                <img src={logoDark} alt="" height="20" />
              </span>
            </Col>
            <Col sm={12}>
              © 2026–2027 HireNeuron. All rights reserved. •{" "}
              <a href="mailto:support@hireneuron.com" className="policy_text">
                support@hireneuron.com
              </a>{" "}
              •{" "}
              <a
                href="https://hireneuron.com/privacy-policy"
                className="policy_text"
                id="as-privacy"
              >
                Privacy Policy
              </a>
            </Col>
          </Row>
        </Container>
      </footer>
    </React.Fragment>
  );
};

export default Footer;
